<template>
  <div class="custom-detail">
    <paasDetail
      ref="paasDetail"
      :params="params"
      :config="config"
      :menuApiName="menuApiName"
      :fetchSubData="fetchSubData"
      @loaded='loaded'
    />
  </div>
</template>

<script>
import paasDetail from '../../pages/detail/detail.vue'
import paasApi from './api'
import {HEADER_PARAMS_KEYS, BUTTON_API_NAME} from 'fe-coms-share/paas/constants/index'

// 统一响应处理
import response from '../../../../../utils/response'
import i18n from './i18n.js'
import {cloneDeep, merge} from 'lodash-es'
import menuHandleMixin from '../mixin/menu-handle'

const pageText = window.fe.getPageText(i18n)

export default {
  props: {
    pageParams: {
      type: Object,
      default: null
    },
    pageConfig: {
      type: Object,
      default: () => ({})
    },
    configType: String
  },
  mixins: [menuHandleMixin],
  data () {
    const id = this.pageParams ? this.pageParams.id : this.$route.query.id
    const params = this.pageParams ||  this.$route.params
    const { objectApiName, permissionPointCode } = params
    params.operationApiName = permissionPointCode
    params.id = id
    return {
      pageText,
      params,
      id,
      formData: {},
      config: merge({
        [objectApiName]: {
          buttons: {
            [BUTTON_API_NAME.BUTTON_DELETE]: {
              event: {
                click: (buttonParams) => {
                  console.log('buttonParams', buttonParams)
                  this.deleteDetail(buttonParams)
                }
              }
            }
            // [BUTTON_API_NAME.BUTTON_PRINT]: {
            //   event: {
            //     click: (buttonParams) => {
            //       this.getPrint(buttonParams)
            //     }
            //   }
            // }
          }
        }
      }, this.pageConfig),
      printApiName: '',
      pagination: {}
    }
  },
  methods: {
    loaded (schema) {
      this.$emit('loaded', schema)
    },
    async fetchSubData ({subSchema}) {
      if (this.configType === 'popupConfig') {
        this.$set(this, 'formData', cloneDeep(this.pageParams.row) || {})
        this.paasPage.updateData(this.formData)
      } else {
        await this.formDataHandle(subSchema)
        this.paasPage.updateData(this.formData)
      }
    },
    async formDataHandle (subSchema) {
      const data = await this.getDetail()
      await Promise.all(
        (subSchema || []).map(v => {
          const newPagination = 'pagination' + v.objectApiName
          this.$set(this.pagination, newPagination, {
            page: 1,
            pageSize: 10,
            total: 0,
            totalPage: 0,
            pageSizes: [10, 20, 50, 100]
          })
          this.subSchemaConfig(v, newPagination)
          return this.getSubDetail(data, v)
        })
      )
      this.formData = data
    },
    async getSubDetail (data = null, {objectApiName: subObjectApiName, layoutApiName, subObjectParamName, relationFieldApiName}) {
      const newPagination = 'pagination' + subObjectApiName
      const {objectApiName} = this.params
      const api = paasApi.getSlaveDetails
      const promise = this.$http(api.type, api.url + `/${objectApiName}/${subObjectApiName}/${layoutApiName}/${relationFieldApiName}`, {
        aPaaS_SequenceId: this.id,
        page: this.pagination[newPagination].page,
        pageSize: this.pagination[newPagination].pageSize
      }, this.headerParams)
      const res = await response(promise)
      let content = []
      if (res.isOk) {
        content = res.content
        this.pagination[newPagination].total = res.count
      }
      data ? data[subObjectParamName] = content : this.$refs.paasDetail.updateTableDataRelation(subObjectApiName, content)
    },
    async getDetail () {
      const api = paasApi.valueDetails
      const {objectApiName, operationApiName} = this.params
      const promise = this.$http(api.type, `${api.url}/${objectApiName}/${operationApiName}`, {
        aPaaS_SequenceId: this.id
      }, this.headerParams)
      const res = await response(promise)
      if (res.isOk) {
        return res.content
      }
      return {}
    },
    // 删除
    async deleteDetail () {
      this.$confirm(this.pageText.deleteInformation, this.pageText.tip, {
        confirmButtonText: this.pageText.confirm,
        type: 'warning'
      })
        .then(async () => {
          const api = paasApi.deleteDetail
          const { objectApiName } = this.params
          const promise = this.$http(api.type, `${api.url}/${objectApiName}`, {
            aPaaS_SequenceId: this.id
          }, this.headerParams)
          const res = await response(promise, {
            loadingOptions: {
              text: this.pageText.loading
            }
          })
          if (res.isOk) {
            this.$message.success(this.pageText.successfullyDelete)
            this.handleBack()
          }
        })
    },
    // download (data) {
    //   const url = window.URL.createObjectURL(new Blob([data], {'type': 'application/pdf'}))
    //   const link = document.createElement('a')
    //   link.setAttribute('style', 'display:none;')
    //   link.setAttribute('target', '_blank')
    //   link.href = url
    //   link.download = url + '.pdf'
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // },
    handleBack () {
      this.$router.go(-1)
    },
    subSchemaConfig (v, newPagination) {
      this.$set(this.config, v.objectApiName, {
        table: {
          props: {
            pagination: () => this.pagination[newPagination],
            total: () => this.pagination[newPagination].total
          },
          event: {
            fetchData: (pagination) => {
              this.pagination[newPagination].page = pagination.page
              this.pagination[newPagination].pageSize = pagination.pageSize
              this.getSubDetail(null, v)
            }
          }
        }
      })
    }
  },
  computed: {
    headerParams () {
      const {tenantType, objectApiName, layoutApiName, operationApiName} = this.params
      return {
        [HEADER_PARAMS_KEYS.tenantType]: tenantType,
        [HEADER_PARAMS_KEYS.objectApiName]: objectApiName,
        [HEADER_PARAMS_KEYS.layoutApiName]: layoutApiName,
        [HEADER_PARAMS_KEYS.operationApiName]: operationApiName,
        [HEADER_PARAMS_KEYS.menuApiName]: this.menuApiName,
        ...this.businessToken
      }
    },
    businessToken () {
      const {businessToken} = this.$route.query
      return businessToken ? {businessToken} : {}
    },
    paasPage () {
      return this.$refs.paasDetail
    }
  },
  components: {
    paasDetail
  }
}
</script>
